import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Layout } from "@/components/Layout";
import Landing from "@/pages/Landing";
import SpeedTest from "@/pages/SpeedTest";
import MyIP from "@/pages/MyIP";
import DownDetector from "@/pages/DownDetector";
import FixMyInternet from "@/pages/FixMyInternet";
import Admin from "@/pages/Admin";
import NewsIndex from "@/pages/NewsIndex";
import NewsArticle from "@/pages/NewsArticle";
import { ToolsIndex, WifiQRTool, DnsTool, WhoisTool, PortTool, MacTool, SubnetTool } from "@/pages/Tools";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/speed-test" element={<SpeedTest />} />
              <Route path="/my-ip" element={<MyIP />} />
              <Route path="/down-detector" element={<DownDetector />} />
              <Route path="/fix-my-internet" element={<FixMyInternet />} />
              <Route path="/news" element={<NewsIndex />} />
              <Route path="/news/:slug" element={<NewsArticle />} />
              <Route path="/tools" element={<ToolsIndex />} />
              <Route path="/tools/wifi-qr" element={<WifiQRTool />} />
              <Route path="/tools/dns-lookup" element={<DnsTool />} />
              <Route path="/tools/whois" element={<WhoisTool />} />
              <Route path="/tools/port-check" element={<PortTool />} />
              <Route path="/tools/mac-lookup" element={<MacTool />} />
              <Route path="/tools/subnet-calculator" element={<SubnetTool />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
